import React ,{useState,useEffect} from 'react'
import { useNavigate,useParams,useLocation } from 'react-router-dom'
import campaignService from '../../services/campaign.service'
import Loading from '../common/Loading';
import { DataGrid } from '@mui/x-data-grid';
import {toast} from 'react-toastify'
function CampaignStop() {
    let { state } = useLocation();
    const {campaignId} = useParams();
   const [statusChanged,setStatusChanged] = useState(false)
   const [disableStop,setDisableStop] = useState(true)
   const [delMsg,setDelMsg] = useState("")
   const getStatus = (id)=>{
        let retVal = ""
        switch (id) {
            case 0:
                retVal="Pending"
                break;
            case 1:
                retVal="In Process"
                break;
            case 2:
                retVal="Finished"
                break;
            case 3:
                retVal="Error"
                break
            default:
                retVal="Unknown"
                break;
        }
        return retVal
   }
   const handleTextChange = (e)=>{
    setDelMsg(e.target.value);
   
   }
   const handleStopClick = (e)=>{
        e.preventDefault();
        if(delMsg === "Stop Immediately"){
            campaignService.updateCampaign(campaignId,3)
            .then(res=>{
                toast.success("Campaign Status Changed!",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
                setStatusChanged(true)
            })
            .catch(err=>{
                toast.error("Error While changing status",{
                    position:toast.POSITION.BOTTOM_RIGHT
                })
                console.log(err)
            })
        }else{
            toast.error("Please enter proper message",{
                position:toast.POSITION.BOTTOM_RIGHT
            })
        }
   }
  return (
   <>
     <div className="container container-xxl">
         <div className="pagetitle d-flex justify-content-between">
                  <h1>Stop Campaign</h1>
        </div>
        <div className="card">
          <div className="card-body p-4">
                <div className="d-flex justify-content-between">
                    <div className="d-flex flex-column">
                        <span><strong>Clinic Name : </strong>{state && state.info.clinicName}</span>
                        <span><strong>Name : </strong>{state && state.info.name}</span>
                        <span><strong>Title : </strong>{state && state.info.title}</span>
                       
                    </div>
                    <div>
                    <span><strong>Current Status : {statusChanged ? "Error" : state && getStatus(state.info.status)}</strong></span>
                    </div>
                    <div className="d-flex flex-column">
                            <span><strong>Id : </strong> {state && state.info.id}</span>
                            <span><strong>Type : </strong> {state && state.info.type}</span>
                            <span><strong>Category : </strong>{state && state.info.category}</span>
                    </div>
                </div>
               
          </div>
        </div>
       
        <div className="row">
            <div className="col-3"></div>
            <div className="col-6">
                <div className="card bg-warning">
                    <div className="card-body p-3">
                            <p className="h3">Warning! Use only when you want to stop the Campaign from running further.</p>
                            <div className="form-group mt-4">
                              <input type="text" onChange={handleTextChange} placeholder="Stop Immediately" className="form-control" />
                                <div className="form-text">Enter "Stop Immediately" and press "Stop" to change the status.</div>
                            </div>
                            <div className="d-flex justify-content-center mt-4">
                                <button className="btn btn-lg btn-danger" onClick={handleStopClick}>Stop</button>
                            </div>
                    </div>
                </div>
            </div>
        </div>
       
       
    </div>
   </>
  )
}

export default CampaignStop